var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import { styled } from "@filadd/phi-plus-styled-system/jsx";
import { Spinner } from "../Spinner";
import { Button as StyledButton, } from "./RawButton";
export const Button = forwardRef((_a, ref) => {
    var { loading, disabled, variant, color, children } = _a, rest = __rest(_a, ["loading", "disabled", "variant", "color", "children"]);
    const spinnerColor = variant === "solid" ? "white" : color;
    const trulyDisabled = loading || disabled;
    return (_jsx(StyledButton, Object.assign({ disabled: trulyDisabled, ref: ref, color: color, variant: variant }, rest, (loading ? { "data-loading": true } : {}), { children: loading ? (_jsxs(_Fragment, { children: [_jsx(Spinner, { width: "1.1em", height: "1.1em", borderBottomColor: "transparent", borderLeftColor: "transparent", borderColor: spinnerColor }), _jsx(styled.span, { children: children })] })) : (children) })));
});
Button.displayName = "Button";
//# sourceMappingURL=Button.js.map